<template>
    <div>
        <button
            v-if="isActionButton"
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            :class="buttonClasses"
            :data-oevent-category="actionTms.category"
            :data-oevent-action="actionTms.action"
            :data-oevent-label="actionTms.label"
            :data-bs-target="'#' + id"
        >
            {{ actionLabel }}
        </button>
        <button
            v-else
            class="ob1-link-arrow"
            data-bs-toggle="modal"
            :class="buttonClasses"
            :data-oevent-category="actionTms.category"
            :data-oevent-action="actionTms.action"
            :data-oevent-label="actionTms.label"
            :data-bs-target="'#' + id"
        >
            {{ actionLabel }}
        </button>
        <div
            :id="id"
            :class="imageUrl ? 'ob1-modal-visual' : ''"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            :aria-labelledby="labelId"
            aria-hidden="true"
            data-ob1-component="Popin"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            :aria-label="modalCloseLabel"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button type="button" class="btn-close ob1-link-arrow back" data-bs-dismiss="modal">
                            {{ modalCloseLabel }}
                        </button>
                    </div>

                    <div v-if="imageUrl" class="modal-body">
                        <div class="ob1-modal-body-visual">
                            <div class="ob1-modal-img">
                                <img :src="imageUrl" :alt="imageAlt">
                            </div>
                            <div class="ob1-modal-content">
                                <h4
                                    v-if="modalTitle"
                                    :id="labelId"
                                    class="h3"
                                    v-html="modalTitle"
                                />
                                <p v-if="modalContent">
                                    {{ modalContent }}
                                </p>
                                <div class="ob1-modal-footer-visual">
                                    <button
                                        v-if="isModalButtonPrimary"
                                        v-bind="isModalButtonClose ? { 'data-bs-dismiss': 'modal' } : {}"
                                        class="btn btn-primary m-0"
                                        type="button"
                                    >
                                        {{ modalButtonLabel }}
                                    </button>
                                    <button
                                        v-else
                                        v-bind="isModalButtonClose ? { 'data-bs-dismiss': 'modal' } : {}"
                                        class="btn btn-secondary m-0"
                                        type="button"
                                    >
                                        {{ modalButtonLabel }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <template v-else>
                        <div class="modal-body">
                            <h4
                                v-if="modalTitle"
                                :id="labelId"
                                class="h3"
                                v-html="modalTitle"
                            />
                            <p v-if="modalContent">
                                {{ modalContent }}
                            </p>
                            <slot name="modalBody" />
                            <div v-if="alertHtmlContent" class="alert-container additional-message" v-html="alertHtmlContent" />
                        </div>
                        <div class="modal-footer d-inline-flex flex-column flex-md-row-reverse justify-content-center">
                            <button
                                v-if="isModalButtonPrimary"
                                v-bind="isModalButtonClose ? { 'data-bs-dismiss': 'modal' } : {}"
                                class="btn btn-primary mx-0 mb-2 ms-md-2 mb-md-0"
                                type="button"
                            >
                                {{ modalButtonLabel }}
                            </button>
                            <button
                                v-else
                                v-bind="isModalButtonClose ? { 'data-bs-dismiss': 'modal' } : {}"
                                class="btn btn-secondary m-0"
                                type="button"
                            >
                                {{ modalButtonLabel }}
                            </button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import {TmsGaDto} from "../../ob1/dto/TmsGaDto";

export default defineComponent({
    name: "ModalDialog",
    props: {
        // id de la modal
        id: {
            type: String,
            required: true
        },
        actionLabel: {
            type: String,
            required: true
        },
        modalCloseLabel: {
            type: String,
            required: false,
            default: "Fermer"
        },
        modalTitle: {
            type: String,
            required: false,
            default: null
        },
        modalContent: {
            type: String,
            required: false,
            default: null
        },
        isModalButtonClose: {
            type: Boolean,
            required: false,
            default: true
        },
        modalButtonLabel: {
            type: String,
            required: true
        },
        isModalButtonPrimary: {
            type: Boolean,
            required: false,
            default: true
        },
        isActionButton: {
            type: Boolean,
            required: false,
            default: true
        },
        imageUrl: {
            type: String,
            required: false,
            default: null
        },
        imageAlt: {
            type: String,
            required: false,
            default: null
        },
        alertHtmlContent: {
            type: String,
            required: false,
            default: null
        },
        tmsCategory: {
            type: String,
            required: false,
            default: ""
        },
        tmsLabel: {
            type: String,
            required: false,
            default: "ouverture-popin"
        },
        buttonClasses: {
            type: String,
            required: false,
            default: ""
        },
    },
    computed: {
        labelId() {
            return this.id + '-label'
        },
        actionTms(): TmsGaDto {
            return {
                category: this.tmsCategory,
                action: toBroadbandTmsFormat(this.actionLabel),
                label: toBroadbandTmsFormat(this.tmsLabel)
            }
        }
    }
})
</script>

<style scoped lang="scss">

</style>
